import React from 'react';
import { Link } from "@StarberryUtils";
import "./GetInTouch.scss";

const GetInTouch = ({ title, email, phone }) => {
  return (
    <div className="get-in-touch-wrapper">
      <div className="contact-heading text-lg-bold-24-18">{title}</div>      
      <div className="contact-links">
        <Link href={`tel:${phone}`} className="btn btn-outline">
        {phone}
        </Link>        
        <Link href={`mailto:${email}`} className="btn btn-outline">
        {email}
        </Link>
      </div>
    </div>
  );
};

export default GetInTouch;
